// extracted by mini-css-extract-plugin
export var dividerContainer = "_7a-0";
export var line = "_7a-1";